import { PersonInfo } from './PersonInfo';

export interface Doctor extends PersonInfo {
  [key: string]: unknown;
}

export const defaultDoctor: Doctor = {
  titleBefore: '',
  titleAfter: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  note: ''
}
